import { useTranslation } from 'react-i18next';
import { MessageBubble } from '../../components/ui/MessageBubble';
import { StatusIcon } from '../../components/ui/StatusIcon';
import type { ShipperMessage, ShipperMessageTemplate } from '../../api/types';
import styles from './ShipperMessagesTab.module.css';

const TEMPLATE_TITLES: Record<ShipperMessageTemplate, string> = {
  BOOKED: 'Booked',
  ASSIGNED: 'Truck assigned',
  LOADED: 'Loaded',
  DELAYED: 'Delay',
  ARRIVING: 'Arriving',
  DELIVERED_POD: 'Delivered + POD',
  DAILY_SUMMARY: 'Daily update',
};

/** Messages tab (#294): every message DNM sent the shipper, newest first, as the shipper saw it. */
export function ShipperMessagesTab({ messages }: { messages: ShipperMessage[] }) {
  const { t } = useTranslation();
  if (messages.length === 0) {
    return (
      <div className={styles.empty}>
        <StatusIcon name="chat" size={28} />
        <p className={styles.emptyTitle}>{t('shipments.shipperMessagesTab.emptyTitle')}</p>
        <p className={styles.emptyHint}>{t('shipments.shipperMessagesTab.emptyHint')}</p>
      </div>
    );
  }
  const newestFirst = [...messages].sort((a, b) => Date.parse(b.sentAt) - Date.parse(a.sentAt));
  return (
    <ul className={styles.list} aria-label={t('shipments.shipperMessagesTab.listLabel')}>
      {newestFirst.map((m) => (
        <li key={m.id} className={styles.item}>
          <MessageBubble
            title={TEMPLATE_TITLES[m.template] ?? 'Message'}
            text={m.text}
            channel={m.channel}
            at={m.sentAt}
            deliveryState={m.deliveryState}
          />
        </li>
      ))}
    </ul>
  );
}
